import {toast} from 'react-toastify'
import Apiservices from '../../lib/ApiServices'
import ApisMethods from './apisMethods'

const Manufacturers = {
  destroy: (id: number, callback: any, setIsLoading: any) => {
    ApisMethods().destroy(`/vendor/manufacturers/${id}`, callback, setIsLoading)
  },
  putStatus: (id: number | undefined, data: any, callback: any, setIsLoading: any) => {
    ApisMethods().put(`/vendor/manufacturers/status/${id}`, data, callback, setIsLoading)
  },
  get: (
    searchText: string,
    rowsPerPage: number,
    page: number,
    callback: any,
    setIsLoading: any
  ) => {
    let url = `/vendor/manufacturers?page=${page}&per_page=${rowsPerPage}`
    if (searchText) {
      url = url + `&search=${searchText}`
    }
    ApisMethods().get(url, callback, setIsLoading)
  },
  add: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/manufacturers`, data, callback, setIsLoading)
  },
  put: (id: number | undefined, data: any, callback: any, setIsLoading: any) => {
    ApisMethods().put(`/vendor/manufacturers/${id}`, data, callback, setIsLoading)
  },
}
export default Manufacturers
